module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[5]),
      expression: "getScreenSize < 2 && !delayedLoading[5]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Selection')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.mic),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "mic", $$v)
      },
      expression: "getSettingsDevice.mic"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/Standard'),
      "value": "IN0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/iepe'),
      "value": "IN1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/line'),
      "value": "IN2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/horizontal'),
      "value": "IN3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/vertical'),
      "value": "IN4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Polarisation')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.micpol),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "micpol", $$v)
      },
      expression: "getSettingsDevice.micpol"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/On'),
      "value": "VS1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/Off'),
      "value": "VS0"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Frequency')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.freqmode),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "freqmode", $$v)
      },
      expression: "getSettingsDevice.freqmode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/Disable'),
      "value": "SC0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/11octave'),
      "value": "SC1FA0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/13octave'),
      "value": "SC1FA1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/11wOctave'),
      "value": "SC1FA2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/13wOctave'),
      "value": "SC1FA3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Resolution')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.resolution),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "resolution", $$v)
      },
      expression: "getSettingsDevice.resolution"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "50 ms",
      "value": "UN50"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "100 ms",
      "value": "UN100"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "125 ms",
      "value": "UN125"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "500 ms",
      "value": "UN500"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1 s",
      "value": "US01"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "5 s",
      "value": "US05"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1 min",
      "value": "US60"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "10 min",
      "value": "US600"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Duration')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.duration),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "duration", $$v)
      },
      expression: "getSettingsDevice.duration"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "24 h",
      "value": "H24"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1 h",
      "value": "H01"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "infoContainer"
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "title": _vm.$l('settings/device/Meter')
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.getSettingsDevice.meterscale <= 70
    },
    on: {
      "click": _vm.decreaseClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/decrease')))])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-size": "16px"
    },
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.getSettingsDevice.meterscale - 80) + " dB / " + _vm._s(_vm.getSettingsDevice.meterscale) + " dB \n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.getSettingsDevice.meterscale >= 130
    },
    on: {
      "click": _vm.increaseClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/increase')))])], 1)], 1)], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "value": "1",
      "title": _vm.$l('settings/device/Values')
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("F")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("I")])], 1), _vm._v(" "), _vm._l((_vm.getSettingsDevice.valuesAll), function(value, i) {
    return _c('el-row', {
      key: value[0]
    }, [_c('el-col', {
      attrs: {
        "span": (value.length == 3) ? 6 : 9
      }
    }, [_c('el-color-picker', {
      model: {
        value: (_vm.getUnsavedLocalSettings.interface.colorsnoise[i]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.interface.colorsnoise, i, $$v)
        },
        expression: "getUnsavedLocalSettings.interface.colorsnoise[i]"
      }
    }), _c('div', {
      staticClass: "value-name"
    }, [_vm._v(_vm._s(_vm.getDeviceValueName(value)))])], 1), _vm._v(" "), _c('el-checkbox-group', {
      staticClass: "value-checkbox",
      model: {
        value: (_vm.getSettingsDevice.valsel),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsDevice, "valsel", $$v)
        },
        expression: "getSettingsDevice.valsel"
      }
    }, _vm._l((value), function(subvalue) {
      return _c('el-col', {
        key: subvalue,
        attrs: {
          "span": 6
        }
      }, [_c('el-checkbox', {
        attrs: {
          "label": subvalue
        },
        on: {
          "change": function($event) {
            return _vm.checkboxChanged(subvalue)
          }
        }
      })], 1)
    }), 1)], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/device/Special')
    }
  }, _vm._l((_vm.getSettingsSpecval.valselsp), function(item) {
    return _c('el-row', {
      key: item.name,
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "lg": 2
      }
    }, [(item.name == 'MV') ? _c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/movingValue')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.name != 'MV') ? _c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": item.name
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 22
      }
    }, [(item.name == 'LEQDay' && item.enabled) ? _c('el-form-item', {
      staticClass: "el-form-item-full"
    }, [_c('div', {
      staticClass: "LEQDayContainer"
    }, [_c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "sm": 8,
        "md": 8,
        "lg": 6
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/value')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsSpecval.leqday),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "leqday", $$v)
        },
        expression: "getSettingsSpecval.leqday"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/device/timeControlled'),
        "value": "tc"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/device/measurementControlled'),
        "value": "mc"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 8,
        "md": 8,
        "lg": 11
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/start_stop')
      }
    }, [_c('el-row', [_c('el-col', [_c('el-time-select', {
      attrs: {
        "disabled": _vm.getSettingsSpecval.leqday == 'mc',
        "placeholder": _vm.$l('settings/device/startTime'),
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '24:00'
        }
      },
      model: {
        value: (_vm.getSettingsSpecval.leqdaystart),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "leqdaystart", $$v)
        },
        expression: "getSettingsSpecval.leqdaystart"
      }
    }), _vm._v(" "), _c('el-time-select', {
      attrs: {
        "disabled": _vm.getSettingsSpecval.leqday == 'mc',
        "placeholder": _vm.$l('settings/device/endTime'),
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '24:00',
          minTime: _vm.getSettingsSpecval.leqdaystart
        }
      },
      model: {
        value: (_vm.getSettingsSpecval.leqdaystop),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "leqdaystop", $$v)
        },
        expression: "getSettingsSpecval.leqdaystop"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 3,
        "md": 3,
        "lg": 3
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/trigger')
      }
    }, [_c('el-row', [_c('el-col', [_c('el-input-number', {
      model: {
        value: (_vm.getSettingsSpecval.leqdayval),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "leqdayval", $$v)
        },
        expression: "getSettingsSpecval.leqdayval"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (item.name == 'MV' && item.enabled) ? _c('el-form-item', {
      staticClass: "el-form-item-full"
    }, [_c('div', {
      staticClass: "LEQDayContainer"
    }, [_c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "lg": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/value')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsSpecval.maval),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "maval", $$v)
        },
        expression: "getSettingsSpecval.maval"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/device/movingAverage'),
        "value": "ma"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "L95",
        "value": "l95"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "L50",
        "value": "l50"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "L1",
        "value": "l1"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/duration')
      }
    }, [_c('el-time-picker', {
      attrs: {
        "picker-options": {
          selectableRange: '00:00:00 - 01:00:00'
        }
      },
      model: {
        value: (_vm.getSettingsSpecval.mavaldurationPicker),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "mavaldurationPicker", $$v)
        },
        expression: "getSettingsSpecval.mavaldurationPicker"
      }
    }), _vm._v(" "), _c('el-input-number', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticStyle: {
        "width": "100%"
      },
      model: {
        value: (_vm.getSettingsSpecval.mavalduration),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "mavalduration", $$v)
        },
        expression: "getSettingsSpecval.mavalduration"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "sm": 12,
        "md": 12,
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/threshold')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsSpecval.mavalltype),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "mavalltype", $$v)
        },
        expression: "getSettingsSpecval.mavalltype"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/audioRecording/Disable'),
        "value": 0
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/audioRecording/Lower'),
        "value": 1
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/audioRecording/Greater'),
        "value": 2
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/audioRecording/Both'),
        "value": 3
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "sm": 11,
        "lg": 11
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full pixel",
      attrs: {
        "label": _vm.$l('settings/audioRecording/lowerThan')
      }
    }, [_c('el-input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.getSettingsSpecval.mavalltype == 0 || _vm.getSettingsSpecval.mavalltype == 2,
        "min": 0,
        "max": 150
      },
      model: {
        value: (_vm.getSettingsSpecval.mavallevel[0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval.mavallevel, 0, $$v)
        },
        expression: "getSettingsSpecval.mavallevel[0]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "line",
      attrs: {
        "sm": 2,
        "lg": 2
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full pixel",
      attrs: {
        "label": " "
      }
    }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 11,
        "lg": 11
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full pixel",
      attrs: {
        "label": _vm.$l('settings/audioRecording/greaterThan')
      }
    }, [_c('el-input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.getSettingsSpecval.mavalltype == 0 || _vm.getSettingsSpecval.mavalltype == 1,
        "min": 0,
        "max": 150
      },
      model: {
        value: (_vm.getSettingsSpecval.mavallevel[1]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval.mavallevel, 1, $$v)
        },
        expression: "getSettingsSpecval.mavallevel[1]"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)]) : _vm._e()], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/device/Advance')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Mic check')
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": -10,
      "max": 140,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsDevice.miccheckvalue),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "miccheckvalue", $$v)
      },
      expression: "getSettingsDevice.miccheckvalue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Mic check time')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.micchecktime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "micchecktime", $$v)
      },
      expression: "getSettingsDevice.micchecktime"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/midnight'),
      "value": "23"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/noon'),
      "value": "11"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/testOpt')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.testOptionsValue),
      callback: function($$v) {
        _vm.testOptionsValue = $$v
      },
      expression: "testOptionsValue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "pixel",
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.testOptions()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/test')))])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "pixel",
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/SDFreeSpace')
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.getSettingsDevice.sdfreelimit),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "sdfreelimit", $$v)
      },
      expression: "getSettingsDevice.sdfreelimit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    staticClass: "startstop-title",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/autostart')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "right-pull",
    attrs: {
      "size": "mini",
      "type": "success",
      "icon": "plus"
    },
    on: {
      "click": _vm.addStartstopGroup
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.getSettingsStartstop.groups), function(group, index) {
    return _c('el-collapse-item', {
      key: group,
      attrs: {
        "title": 'Group ' + (index + 1)
      }
    }, [_c('el-row', [_c('div', {
      staticClass: "remove-startstop-button"
    }, [_c('el-button', {
      staticClass: "right-pull",
      attrs: {
        "size": "mini",
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteStartstopGroup(group)
        }
      }
    })], 1)]), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "md": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/startstopActive')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsStartstop['enable' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'enable' + group, $$v)
        },
        expression: "getSettingsStartstop['enable'+group]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 10
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/days')
      }
    }, [_c('el-select', {
      attrs: {
        "disabled": !_vm.getSettingsStartstop['enable' + group],
        "multiple": ""
      },
      model: {
        value: (_vm.getSettingsStartstop['days' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'days' + group, $$v)
        },
        expression: "getSettingsStartstop['days'+group]"
      }
    }, [_c('el-option', {
      key: "1",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[1],
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "2",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[2],
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "3",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[3],
        "value": "3"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "4",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[4],
        "value": "4"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "5",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[5],
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "6",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[6],
        "value": "6"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "7",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[0],
        "value": "7"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 10
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/types')
      }
    }, [_c('el-select', {
      attrs: {
        "disabled": !_vm.getSettingsStartstop['enable' + group],
        "multiple": ""
      },
      model: {
        value: (_vm.getSettingsStartstop['types' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'types' + group, $$v)
        },
        expression: "getSettingsStartstop['types'+group]"
      }
    }, [_c('el-option', {
      key: "noise",
      attrs: {
        "label": _vm.$l('calendar/noise'),
        "value": "noise"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "weather",
      attrs: {
        "label": _vm.$l('calendar/weather'),
        "value": "weather"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "adio",
      attrs: {
        "label": _vm.$l('calendar/adio'),
        "value": "adio"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "md": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/start')
      }
    }, [_c('el-time-select', {
      attrs: {
        "disabled": !_vm.getSettingsStartstop['enable' + group],
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        }
      },
      model: {
        value: (_vm.getSettingsStartstop['start' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'start' + group, $$v)
        },
        expression: "getSettingsStartstop['start'+group]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/stop')
      }
    }, [_c('el-time-select', {
      attrs: {
        "disabled": !_vm.getSettingsStartstop['enable' + group],
        "picker-options": {
          start: _vm.getSettingsStartstop['start' + group],
          step: '00:15',
          end: '23:45'
        }
      },
      model: {
        value: (_vm.getSettingsStartstop['stop' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'stop' + group, $$v)
        },
        expression: "getSettingsStartstop['stop'+group]"
      }
    })], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Format SD",
      "visible": _vm.formatSDdialog,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.formatSDdialog = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$l('settings/device/formatSDdialog')) + " ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer dialog-footer"
    },
    slot: "footer dialog-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.formatSDdialog = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + " ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.formatSDdialog = false, _vm.formatSD()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogContinue')) + " ")])], 1)]), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[5]) ? _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.restartLoading,
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.restartNoiseClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/Restart')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.setInstrument()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/Set instrument')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.formatSDLoading,
      "disabled": _vm.getStatus.noise,
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.formatSD()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/Format')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.checkSpaceLoading,
      "disabled": _vm.getStatus.noise,
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.checkSD()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/CheckSD')))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1579e8f2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/Device.vue
// module id = 444
// module chunks = 1